import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import {
  Notification,
  PhoneNumber,
  User,
  UserEstab,
  UserEstabId,
  UserListItem
} from './users.model'

@Injectable({
  providedIn: 'root'
})
export class PvtUsersService {
  constructor(private http: HttpClient) {}

  /**
   * @returns Todos os campos de todos os usuários
   */
  listarTodosUsuarios(): Observable<UserListItem[]> {
    return this.http.get<any>(`${environment.apiURL}/users?quick=true`, { withCredentials: true })
  }

  /**
   * @param idOrEmail Pode ser tanto um id como um email
   * @returns Todos os campos de um usuário
   */
  recuperarUsuario(idOrEmail: string): Observable<[User]> {
    return this.http.get<any>(`${environment.apiURL}/users/${idOrEmail}`, { withCredentials: true })
  }

  /**
   * Formata o objeto usuário a partir dos dados
   * @param id
   * @param nome
   * @param email
   * @param pwd
   * @param role número que representa a soma de cada permissão (relativa a uma plataforma)
   * @returns
   */
  setUsuario(
    id: string,
    nome: string,
    email: string,
    pwd: string,
    role: number,
    locale: string,
    estabelecimentos: UserEstab[],
    phoneNumbers: PhoneNumber[],
    timeZone: string,
    blockAccessToVisioAnalytics: boolean,
    tracked?: boolean,
    notification?: Notification,
  ): User {
    const user: User = {
      _id: id,
      nome: nome.trim(),
      email: email,
      pwd: pwd,
      role: role,
      locale: locale,
      estabelecimentos: estabelecimentos,
      phoneNumbers: phoneNumbers,
      blockAccessToVisioAnalytics: blockAccessToVisioAnalytics,
      timeZone: timeZone,
    }

    if (tracked) {
      user['tracked'] = tracked
    }
    if (notification) {
      user['notification'] = notification
    }

    return user
  }

  criarUsuario(
    id: string,
    nome: string,
    email: string,
    pwd: string,
    role: number,
    locale: string,
    estabelecimentos: UserEstab[],
    phoneNumbers: PhoneNumber[],
    timeZone: string,
    blockAccessToVisioAnalytics: boolean
  ): Observable<any> {
    const user = this.setUsuario(id, nome, email, pwd, role, locale, estabelecimentos, phoneNumbers, timeZone, blockAccessToVisioAnalytics)
    console.log('user', user)
    return this.http.post<any>(`${environment.apiURL}/users`, user, {
      withCredentials: true,
      responseType: 'text' as 'json'
    })
  }

  editarUsuario(
    id: string,
    nome: string,
    email: string,
    pwd: string,
    role: number,
    locale: string,
    estabelecimentos: UserEstab[],
    phoneNumbers: PhoneNumber[],
    timeZone: string,
    blockAccessToVisioAnalytics: boolean,
    tracked?: boolean,
    notification?: Notification
  ): Observable<any> {
    console.log('timezone', timeZone)
    const user = this.setUsuario(
      id,
      nome,
      email,
      pwd,
      role,
      locale,
      estabelecimentos,
      phoneNumbers,
      timeZone,
      blockAccessToVisioAnalytics,
      tracked,
      notification
    )
    return this.http.put<any>(`${environment.apiURL}/users/${user._id}`, user, {
      withCredentials: true,
      responseType: 'text' as 'json'
    })
  }

  deletarUsuario(id: string): Observable<any> {
    return this.http.delete<any>(`${environment.apiURL}/users/${id}`, {
      withCredentials: true,
      responseType: 'text' as 'json'
    })
  }

  getUserByPhoneNumber(phoneNumber: string): Observable<User> {
    return this.http.get<User>(`${environment.apiURL}/users/${phoneNumber}/phone`, {
      withCredentials: true
    })
  }

  getUserEstabelecimentos(id: string): Observable<{ estabelecimentos: UserEstab[]; _id: string }> {
    return this.http.get<any>(`${environment.apiURL}/users/${id}/estabelecimentos`, {
      withCredentials: true,
      responseType: 'json'
    })
  }

  /**
   * Adiciona estabelecimentos no usuário
   * @param payload o formato a ser enviado
   * {
   *    _id 'userA',
   *    estabelecimentos: [{_id: 'estab1', nome: 'estab1', tipo: 'normal', aceito_estabelecimento: false }]
   * }
   */
  addEstabelecimentosToUser(payload: {
    _id: string
    estabelecimentos: UserEstab[]
  }): Observable<any> {
    return this.http.put(`${environment.apiURL}/users/addestabelecimentotouser`, payload, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  /**
   * Remove estabelecimentos do usuário
   * @param payload o formato a ser enviado
   * {
   *    _id 'userA',
   *    estabelecimentos: [ {_id: 'estab1'}, {_id: 'estab2'} ]
   * }
   * @returns
   */
  removeEstabelecimentosFromUser(payload: {
    _id: string
    estabelecimentos: UserEstabId[]
  }): Observable<any> {
    return this.http.put(`${environment.apiURL}/users/removeestabelecimentofromuser`, payload, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  /**
   * Atualiza se o usuário está sendo trackeado
   * @param payload objeto com propriedade boolean tracked
   * @returns
   */
  updateTrackedUser(payload: { tracked: boolean }): Observable<any> {
    return this.http.put(`${environment.apiURL}/users/updatetracked`, payload, {
      withCredentials: true,
      responseType: 'text'
    })
  }
}
